// import PropTypes from 'prop-types'
import NextImage from 'next/image'
import Fade from 'react-reveal/Fade'

import { Root } from './Image.style'

const Image = ({ src, flush = false }) => {
  if (!src) return null

  return (
    <Fade duration={1500}>
      <Root $flush={flush}>
        <NextImage src={src} alt="" />
      </Root>
    </Fade>
  )
}

Image.propTypes = {}

Image.defaultProps = {}

export default Image
